import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from './config/config'; 

const recaptchaSiteKey = config.RECAPTCHA_SITE_KEY;

if (!recaptchaSiteKey) {
  console.error('RECAPTCHA_SITE_KEY tidak ditemukan di config.js');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router>
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey}>
      <App />
    </GoogleReCaptchaProvider>
  </Router>
);

// Remove initial loader after React mounts
setTimeout(() => {
  const loader = document.getElementById('initial-loader');
  if (loader) {
    loader.style.opacity = '0';
    loader.style.transition = 'opacity 0.3s ease-out';
    setTimeout(() => loader.remove(), 300);
  }
}, 100);